
import React from 'react';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';

const Logo: React.FC = () => {
  return (
    <Link to="/" className="flex items-center gap-2 text-piano-black dark:text-white">
      <Music className="h-8 w-8 text-piano-gold" />
      <div>
        <h1 className="text-xl font-serif font-semibold">
          <span className="text-piano-black dark:text-white">Piano</span>
          <span className="text-piano-gold">undervisning</span>
        </h1>
        <p className="text-xs text-piano-gray">Pianist Oscar Gilbert</p>
      </div>
    </Link>
  );
};

export default Logo;
